__turbopack_context__.v({
  "announcementCard": "PageCardV2-module-scss-module__OfPnhG__announcementCard",
  "announcementCardBack": "PageCardV2-module-scss-module__OfPnhG__announcementCardBack",
  "announcementImg": "PageCardV2-module-scss-module__OfPnhG__announcementImg",
  "announcementInner": "PageCardV2-module-scss-module__OfPnhG__announcementInner",
  "announcementItem": "PageCardV2-module-scss-module__OfPnhG__announcementItem",
  "announcementSubtitle": "PageCardV2-module-scss-module__OfPnhG__announcementSubtitle",
  "announcementTitle": "PageCardV2-module-scss-module__OfPnhG__announcementTitle",
  "backSide": "PageCardV2-module-scss-module__OfPnhG__backSide",
  "border": "PageCardV2-module-scss-module__OfPnhG__border",
  "content": "PageCardV2-module-scss-module__OfPnhG__content",
  "contentParent": "PageCardV2-module-scss-module__OfPnhG__contentParent",
  "descriptionDiv": "PageCardV2-module-scss-module__OfPnhG__descriptionDiv",
  "flip": "PageCardV2-module-scss-module__OfPnhG__flip",
  "frontSide": "PageCardV2-module-scss-module__OfPnhG__frontSide",
  "isScholarshipCard": "PageCardV2-module-scss-module__OfPnhG__isScholarshipCard",
  "root": "PageCardV2-module-scss-module__OfPnhG__root",
  "title": "PageCardV2-module-scss-module__OfPnhG__title",
  "titleDescription": "PageCardV2-module-scss-module__OfPnhG__titleDescription",
  "titleWithSubtitle": "PageCardV2-module-scss-module__OfPnhG__titleWithSubtitle",
  "underDesc": "PageCardV2-module-scss-module__OfPnhG__underDesc",
  "visibility": "PageCardV2-module-scss-module__OfPnhG__visibility",
});
